module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"aiInterview":"Questions from AI","aiInterviewDescription":"Artificial Intelligence will select and voice the questions for your job. You can make changes if necessary.","recommended":"Recommended","selectionQOver":"The selection of questions is over"}}')
  delete Component.options._Ctor
}
